var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    attrs: {
      "loader": _vm.isSearching,
      "sort": _vm.sort,
      "headers": _vm.headers,
      "records": _vm.records
    },
    on: {
      "sort": function($event) {
        _vm.$emit('sort', $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "head-region",
      fn: function(props) {
        return [_c('v-dropdown', {
          attrs: {
            "items": _vm.regions
          },
          on: {
            "select": function($event) {
              _vm.$emit('filter', $event)
            }
          }
        }, [_c('div', [_c('v-font-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("filter_list")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "margin",
            rawName: "v-margin.left",
            value: (1),
            expression: "1",
            modifiers: {
              "left": true
            }
          }]
        }, [_vm._v("Регион")])], 1)])]
      }
    }, {
      key: "cell-action",
      fn: function(props) {
        return [_c('v-radio', {
          attrs: {
            "value": _vm.value,
            "data": props.item
          },
          on: {
            "input": function($event) {
              _vm.$emit('input', props.item)
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding",
      value: (3),
      expression: "3"
    }]
  }, [_c('v-row', {
    attrs: {
      "align-items": "center"
    }
  }, [_c('v-col', [_c('v-pagination', {
    attrs: {
      "total": _vm.total,
      "display": _vm.display,
      "current": _vm.page
    },
    on: {
      "click": function($event) {
        _vm.$emit('paginate', $event)
      }
    }
  })], 1), _vm._v(" "), _c('v-col', {
    directives: [{
      name: "text-align",
      rawName: "v-text-align.right",
      modifiers: {
        "right": true
      }
    }]
  }, [_vm._t("default")], 2)], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9705bd0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/requestTableInns/RequestTableInns.vue
// module id = 1111
// module chunks = 0